import React, { useEffect } from 'react';
import { domainName } from '../custom-modules/serverAddress';
import { Outlet } from 'react-router-dom';
import './styles/layout.scss';


function Layout() 
{
  
  useEffect(() => 
    {
      const fullPathname = window.location.href;
      if (fullPathname.slice(0, 7) == "http://")
      {
        // window.location.replace(`https://${domainName}`);
      }
    }, []);

  return (
    <div><Outlet /></div>
  );
}

export default Layout;